import { render, staticRenderFns } from "./SearchProfilePerm.vue?vue&type=template&id=04873e26&scoped=true&"
import script from "./searchProfilePerm.ts?vue&type=script&lang=ts&"
export * from "./searchProfilePerm.ts?vue&type=script&lang=ts&"
import style0 from "./SearchProfilePerm.vue?vue&type=style&index=0&id=04873e26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04873e26",
  null
  
)

export default component.exports